import { useQuery } from "@tanstack/react-query";

import { homeQueryKeys } from "@/features/home/api/queryKeys";
import { instance } from "@/lib/axios/instance";

export interface ActiveCampaignDistributionItem {
  integrationId: string;
  name: string;
  displayName: string;
  campaignCount: number;
}

export interface ActiveCampaignDistributionResponse {
  items: ActiveCampaignDistributionItem[];
  totalCampaignCount: number;
}

/**
 * Returns active campaign counts grouped by integration, plus a globally
 * deduplicated total campaign count for the donut center. Scope:

 */
export function useActiveCampaignDistribution(clientId?: string) {
  const query = useQuery({
    queryKey: homeQueryKeys.activeCampaignDistribution(clientId),
    queryFn: async () => {
      const res = await instance.get<ActiveCampaignDistributionResponse>(
        "/api/v2/Home/active-campaign-distribution",
        { params: { clientId: clientId || undefined } },
      );
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
  });

  return {
    rows: query.data?.items ?? [],
    totalCampaignCount: query.data?.totalCampaignCount ?? 0,
    isLoading: query.isPending,
    isError: query.isError,
  };
}
